import {FC, useEffect, useMemo, useState} from 'react'
import {ImageInputComponent} from '../_metronic/assets/ts/components'
import {toAbsoluteUrl} from '../_metronic/helpers'
import {toast} from 'react-toastify'
import {useThemeMode} from '../_metronic/partials'
import Select from 'react-select'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import {DateRangePicker} from 'react-date-range'

type Props = {
  value: string | number | Date | readonly (string | number | Date)[] | undefined
  defaultValue: string | undefined
  inputRef: any
}

export const CustomInput: FC<Props> = ({value, defaultValue, inputRef, ...props}) => {
  return <input {...props} defaultValue={defaultValue} ref={inputRef} />
}

export const CustomTextArea: FC<any> = ({field, form, ...props}) => {
  return (
    <textarea
      className='form-check-input'
      defaultChecked={field.value}
      onChange={(e) => form.setFieldValue(field.name, e.target.value)}
      {...props}
      defaultValue={field.value}
    />
  )
}

export const ImageUpload: FC<any> = ({field, form, ...props}) => {
  const {mode} = useThemeMode()
  const blankImg = toAbsoluteUrl(
    `/media/svg/files/blank-image${mode === 'dark' ? '-dark' : ''}.svg`
  )
  const [imageUrl, setImageUrl] = useState<string>()
  const [error, setError] = useState<string | undefined>()
  useEffect(() => {
    ImageInputComponent.createInsance(`#${field.name.replaceAll('[', '_').replaceAll(']', '')}`)
  }, [field.name])

  const uploadFile = (file: File) => {
    form.setFieldValue(field.name.replaceAll('[', '_').replaceAll(']', '') + '_to_upload', file)
  }
  useEffect(() => {
    if (field.value) setImageUrl(process.env.REACT_APP_BUCKET_URL + '/' + field.value)
  }, [field.value])

  return (
    <>
      <div
        id={field.name.replaceAll('[', '_').replaceAll(']', '')}
        className='image-input image-input-outline'
        data-kt-image-input='true'
        style={{backgroundImage: `url('${props.blankImg || blankImg}')`}}
      >
        {/* begin::Preview existing avatar */}
        <div
          className={`image-input-wrapper w-${props.width || '125px'} h-${props.height || '125px'}`}
          style={{
            backgroundImage: `url('${imageUrl || props.blankImg || blankImg}')`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
          }}
        ></div>
        {/* end::Preview existing avatar */}

        {/* begin::Label */}
        <label
          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
          data-kt-image-input-action='change'
          data-bs-toggle='tooltip'
          title='Change avatar'
        >
          <i className='bi bi-pencil-fill fs-7'></i>

          <input
            type='file'
            onChange={(e) => {
              if (e.target.files) {
                if (e.target.files[0].size > (props.limit || 120) * 1024) {
                  toast.error(
                    `File too large!! max size is ${
                      props.limit >= 1024 ? (props.limit || 120) / 1024 : props.limit || 120
                    }${props.limit >= 1024 ? 'mb' : 'kb'}`
                  )
                  setError(
                    `File too large!! max size is ${
                      props.limit >= 1024 ? (props.limit || 120) / 1024 : props.limit || 120
                    }${props.limit >= 1024 ? 'mb' : 'kb'}`
                  )
                } else {
                  uploadFile(e.target.files[0])
                  setError(undefined)
                }
              }
            }}
            name={field.name}
            accept='.png, .jpg, .jpeg'
          />
          <input type='hidden' name='avatar_remove' />
        </label>
        {/* end::Label */}

        {/* begin::Cancel */}
        <span
          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
          data-kt-image-input-action='cancel'
          data-bs-toggle='tooltip'
          title='Cancel avatar'
          onClick={() => console.log('cancel')}
        >
          <i className='bi bi-x fs-2'></i>
        </span>
        {/* end::Cancel */}

        {/* begin::Remove */}
        <span
          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
          data-kt-image-input-action='remove'
          data-bs-toggle='tooltip'
          title='Remove avatar'
          onClick={() => form.setFieldValue(field.name, '')}
        >
          <i className='bi bi-x fs-2'></i>
        </span>
        {/* end::Remove */}
      </div>
      {error && <div className='text-danger mt-2'>{error}</div>}
    </>
  )
}

export const Switch: FC<any> = ({field, form, ...props}) => {
  return (
    <div className='form-check form-switch form-switch-md form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        type='checkbox'
        defaultChecked={field.value}
        onChange={(e) => form.setFieldValue(field.name, e.target.checked)}
        {...props}
      />
    </div>
  )
}
export const CustomSelect: FC<any> = ({field, form, ...props}) => {
  return (
    <Select
      value={
        props.isMulti
          ? props.options.filter((x: any) => field.value?.includes(x.value))
          : props.options.find((x: any) => field.value === x.value)
      }
      {...props}
      onChange={(e: any) =>
        form.setFieldValue(
          field.name,
          props.isMulti ? e?.map((val: {value: number}) => val.value) : e?.value
        )
      }
      className='react-select-container'
      classNamePrefix='react-select'
      isClearable={true}
    />
  )
}
export type dateRangeProp = {startDate: Date; endDate: Date; key: string}
export const DateRangeComponent: FC<{
  setDateRange: any
  dateRange?: dateRangeProp
}> = ({setDateRange, dateRange}) => {
  console.log('hi')
  const state = useMemo(
    () => [
      dateRange || {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ],
    [dateRange]
  )

  return (
    <DateRangePicker
      editableDateInputs={true}
      onChange={(item) => setDateRange(item.selection)}
      ranges={state}
    />
  )
}
